import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import SearchReviewListModal from '../../../../views/widget/common/modal/SearchReviewListModal';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { widgetActions } from '../../../../store/modules/widget';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import { message } from 'antd';

class SearchReviewModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  선택된 후기
       */
      selectedReviewList: [],
      /**
       *  선택된 후기 ID
       */
      selectedReviewIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount() {
    this.initiate(this.props.data.selectedId);
  }

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedReviewList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (reviewId) => {
    this.getList({
      reviewId,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;

    toggleModal({
      name: 'searchReviewListModal',
      value: false,
    });
  };

  /**
   *  후기 선택하기
   */
  onSubmit = () => {
    const { selectedReviewList, selectedReviewIdList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;

    /**
     *  상품 후기가 선택 되었는지 체크
     */
    if (!selectedReviewIdList[0]) {
      message.error('상품 후기를 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedReviewIdList[0],
    });

    setData({
      path: [...targetPath, 'linkName'],
      value: `${selectedReviewList[0].productName}-${selectedReviewList[0].productId}`,
    });

    this.closeModal();
  };

  /**
   *  후기 리스트 가져오기
   */
  getList = (option) => {
    const { getReviewList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, sortOption, pagination } = listData;

    getReviewList({
      filterOption,
      sortOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   *  후기 선택 callback
   */
  onCheckReview = (list) => {
    const { selectedReviewIdList } = this.state;
    const { listData } = this.props.data;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = list.filter((id) => id !== selectedReviewIdList[0]);
    }

    const targetList = listData.list.filter((item) => targetIdList.includes(item.id));

    this.setState({
      /**
       *  선택된 후기
       */
      selectedReviewList: targetList,
      /**
       *  선택된 후기 ID
       */
      selectedReviewIdList: targetIdList,
    });
  };

  render() {
    return (
      <SearchReviewListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getReviewList={this.getList}
        onCheckReview={this.onCheckReview}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchReviewListModal.isOpen,
    data: state.widget.searchReviewListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getReviewList: widgetActions.getReviewList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchReviewModalContainer));
